import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JtRichTextEditorComponent } from './jt-rich-text-editor.component';

/**
 * Module for jt-rich-text-editor component.
 *
 * Import this module in place of JtRichTextEditorModule from ng2-ckeditor.
 *
 * @example
 * ```typescript
 * import { JtRichTextEditorModule } from '@customcomponent/jt-rich-text-editor';
 *
 * @NgModule({
 *   imports: [JtRichTextEditorModule]
 * })
 * export class YourModule { }
 * ```
 */
@NgModule({
    declarations: [
        JtRichTextEditorComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        JtRichTextEditorComponent
    ]
})
export class JtRichTextEditorModule { }
